import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PlateInfo from "../../models/plate-info.entity";
import storageService from "../../services/storage.service";
import { ActionRow, SubmitBtn } from "../Inspection/Inspections.styles";
import PaymentHeader from "../Payment/components/PaymentHeader";
import { Container, Form } from "../Payment/Payment.styles";
import DiscountCounpon from "./components/DiscountCoupon/DiscountCoupon";
import { CancelBtn, Row, Subtitle, SummaryBox, Title } from "./Summary.styles";
import { LocalStoreKeysEnum } from "../../models/enums/localstore-keys.enum";
import { InspectionTypeEnum } from "../../models/enums/inspection-type.enum";

const Summary = () => {
  const history = useHistory();

  const originalPrice: any = localStorage.getItem(LocalStoreKeysEnum.LABEL_INSPECTION_PRICE);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [plateInfo, setPlateInfo] = useState<PlateInfo>(new PlateInfo());
  const [price, setPrice] = useState<number>(Number(originalPrice) || 64.90);
  const [hasCoupon, setHasCoupon] = useState<boolean>(false);
  const branchModel = localStorage.getItem('branchModel');

  const goToPayment = () => {
    history.push('payment');
  }

  const formatPrice = (price: number) => {
    const formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
    return formatter.format(price);
  }

  const getDiscountValue = () => {
    const discount = originalPrice - price;
    return formatPrice(Math.abs(discount));
  }

  const getIdentifierLabel = () => {
    return 'Identificador';
  }

  const goToInspection = () => {
    history.push('inspection');
  };

  const getIdentifierValue = () => {
    const localPlateInfo: any = storageService.getObject('plateInfo');
    const inspectionType = localStorage.getItem(LocalStoreKeysEnum.INSPECTION_TYPE_KEY);

    switch (inspectionType) {
      case InspectionTypeEnum.AGRICULTURAL_MACHINE:
      case InspectionTypeEnum.VESSEL:
        return localPlateInfo.chassis;

      case InspectionTypeEnum.VEHICLE:
        return localPlateInfo.plate;

      default:
        return '--';
    }
  }

  useEffect(() => {
    const localPlateInfo: any = storageService.getObject('plateInfo');

    if (localPlateInfo) {
      setPlateInfo(localPlateInfo);
    }
  }, []);

  return (
    <Container>
      <PaymentHeader />
      <Form>
        <SummaryBox>
          <DiscountCounpon
            changePrice={setPrice}
            changeCouponState={setHasCoupon}
          />
          <Row>
            <span>Veículo</span>
            <span>{branchModel || '--'}</span>
          </Row>
          <Row>
            <span>{ getIdentifierLabel() }</span>
            <span>{ getIdentifierValue() }</span>
          </Row>
          <Row>
            <span>Subtotal</span>
            <span>{formatPrice(Number(originalPrice) || 64.90)}</span>
          </Row>
          {hasCoupon && (
            <Row>
              <span>Descontos</span>
              <span>- {getDiscountValue()}</span>
            </Row>
          )}
          <Row>
            <Subtitle>Total</Subtitle>
            <Title>{formatPrice(price)}</Title>
          </Row>
        </SummaryBox>
        <ActionRow>
          <SubmitBtn onClick={() => { goToPayment() }}>Continuar</SubmitBtn>
          <CancelBtn onClick={() => { goToInspection() }}>
            Voltar
          </CancelBtn>
        </ActionRow>
      </Form>
    </Container>
  );
}

export default Summary;
